import { ARIValues, DailySet, ValueTypes } from "../../shared/types";
import { AriType } from "../../updateForm";

export class Extra implements ARIValues {
  ticker: string;
  valueType: ValueTypes;
  dailySet: DailySet[];
  type: AriType;

  constructor(ticker: string, valueType: ValueTypes, dailySet: DailySet[]) {
    this.ticker = ticker;
    this.valueType = valueType;
    this.dailySet = dailySet;
    this.type = AriType.EXTRAS;
  }

  static of(ticker: string, type: ValueTypes, dailySet: DailySet[]): Extra {
    return new Extra(ticker, type, dailySet);
  }
}
